import { FormControlLabel, Grid, Switch } from "@mui/material";
import { makeStyles } from '@mui/styles';
import { useEffect } from "react";
import { useState } from "react";
import { errorMessage } from "../../../util/ConfirmAlertUtil";
import Loading from "../../UI/Loading";
import Select from "../../UI/Select";
import { findByPerfil } from "../../Usuario/api-usuario-perfil";
import { PROFESSOR } from "../../Usuario/Perfil";
import { findBySelectedYearAndTdpUsuarioId, findBySelectedYearAndTdpUsuarioIdVersao2 } from "../api-cronograma";
import CronogramaProfessorTable from "./CronogramaProfessorTable";
import CronogramaProfessorTableV2 from "./CronogramaProfessorTableV2";

const useStyles = makeStyles(theme => ({
  mediaPrintElement: {
    '@media print': {
      display: 'none'
    }
  }
}));

const CronogramaProfessorContainer = () => {
  const classes = useStyles();
  const [professores, setProfessores] = useState([]);
  const [professor, setProfessor] = useState(null);
  const [isLoadingProfessores, setIsLoadingProfessores] = useState(false);
  const [cronogramas, setCronogramas] = useState([]);
  const [isLoadingCronogramas, setIsLoadingCronogramas] = useState(false);
  const [versao2, setVersao2] = useState(false);

  useEffect(() => {
    setIsLoadingProfessores(true);
    findByPerfil(PROFESSOR).then((data) => {
      if (data.error) {
        errorMessage(data.message);
      } else {
        setProfessores(
          data.map((d) => ({
            description: d.usuario.nome,
            value: d.usuario.id,
          }))
        );
      }
      setIsLoadingProfessores(false);
    });
  }, []);

  useEffect(() => {
    if (professor && professor.value && versao2) {
      setIsLoadingCronogramas(true);
      findBySelectedYearAndTdpUsuarioIdVersao2(professor.value).then((data) => {
        if (data.error) {
          errorMessage(data.message);
        } else {
          setCronogramas(data);
        }
        setIsLoadingCronogramas(false);
      });
    }
    else if (professor && professor.value && !versao2) {
      setIsLoadingCronogramas(true);
      findBySelectedYearAndTdpUsuarioId(professor.value).then((data) => {
        if (data.error) {
          errorMessage(data.message);
        } else {
          setCronogramas(data);
        }
        setIsLoadingCronogramas(false);
      });
    }

  }, [professor, versao2]);

  const onChange = (event) => {
    setProfessor(professores.find((p) => p.value === event.target.value));
  };

  const handleSwitchVersao2Change = name => event => {
    setVersao2(event.target.checked)
  };


  return (
    <Grid container direction="column" spacing={3}>
      <Grid size={3}>
        {isLoadingProfessores ? (
          <Loading description="Carregando Professores..." />
        ) : (
          <>
            <Select
              label={"Professor"}
              value={professor ? professor.value : ""}
              list={professores}
              onChange={onChange}
            />

          </>
        )}
      </Grid>
      <Grid className={classes.mediaPrintElement} size={12}>
        <>
          <FormControlLabel
            control={
              <Switch
                checked={versao2 ? true : false}
                onChange={handleSwitchVersao2Change('ativo')}
                value={versao2 ? true : false}
              />
            }
            label="Versão 2"
          />
        </>
      </Grid>
      <Grid>
        {professor ? (
          <>
            {isLoadingCronogramas ? (
              <Loading description="Carregando Cronogramas" />
            ) : (
              <>
                {versao2 ?
                  <CronogramaProfessorTableV2 cronogramas={cronogramas} /> :
                  <CronogramaProfessorTable cronogramas={cronogramas} />
                }

              </>

            )}
          </>
        ) : (
          ""
        )}
      </Grid>
    </Grid>
  );
};

export default CronogramaProfessorContainer;
